import { provideGalaxyDateAdapter } from '@vendasta/galaxy/datepicker';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DateFormat } from '@vendasta/galaxy/utility/date-utils';
import { PopoverPositions } from '@vendasta/galaxy/popover';

@Component({
  template: `
    <div class="value" [glxyPopover]="popover" (mouseenter)="showTooltip()" (mouseleave)="hideTooltip()">
      {{ value | date }}
    </div>
    <glxy-popover
      #popover
      [positions]="positions"
      [isOpen]="showPopover"
      [hasArrow]="true"
      [highContrast]="false"
      [padding]="'small'"
    >
      <span>{{ ('GALAXY.TABLE.DATE_CELL.LOCAL_TIME' | translate) + ': ' + (value | date: longFormat) }}</span>
      <br />
      <span>{{ ('GALAXY.TABLE.DATE_CELL.UTC' | translate) + ': ' + (value | date: longFormat : '+0000') }}</span>
    </glxy-popover>
  `,
  providers: [provideGalaxyDateAdapter()],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DateRendererComponent {
  positions = [PopoverPositions.Top, PopoverPositions.Bottom];
  showPopover = false;
  longFormat = DateFormat.long;

  private _value: Date | null = new Date(0);

  get value(): Date | null {
    return this._value;
  }

  set value(value: Date | null) {
    const date = value == null ? null : new Date(value);
    this._value = date && !isNaN(date.getTime()) ? date : null;
  }

  showTooltip(): void {
    this.showPopover = true;
  }

  hideTooltip(): void {
    this.showPopover = false;
  }
}
